<template>
    <div v-if="series" class="space-y-4">
        <FlexibleCard headline-id="orgcat" expandable-status="Not-Collapsible">
            <template #header="{ headlineId }">
                <CardHeaderEditable
                    :status="getCardStatus('orgcat')"
                    :edit-button-disabled-explanation="editButtonDisabledMessage('orgcat')"
                    :save-button-disabled-explanation="saveButtonDisabledMessage('orgcat')"
                    @enter-edit-mode="onEnterEditMode('orgcat', $t('organisational-categorization'))"
                    @leave-edit-mode="leaveEditMode('orgcat')"
                    @discard-changes="discardChanges('orgcat')"
                    @save="saveForm('orgcat')"
                >
                    <CardHeadline :headline-id="headlineId">
                        {{ $t('organisational-categorization') }}
                    </CardHeadline>
                </CardHeaderEditable>
            </template>

            <template #body>
                <ContentFormTransition>
                    <EventSeriesOrgCatForm
                        v-if="showForm('orgcat')"
                        ref="seriesOrgCatFormRef"
                        class="p-5"
                        :series-id="seriesId"
                    />
                    <SeriesOrgCatDisplay v-else :series-id="seriesId" />
                </ContentFormTransition>
            </template>
        </FlexibleCard>
    </div>
</template>

<script setup lang="ts">
import CardHeaderEditable from '@/components/Card/CardHeaderEditable.vue';
import CardHeadline from '@/components/Card/CardHeadline.vue';
import FlexibleCard from '@/components/Card/FlexibleCard.vue';
import ContentFormTransition from '@/event/components/ContentFormTransition.vue';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import SeriesOrgCatDisplay from '@/event/displays/series/SeriesOrgCatDisplay.vue';
import EventSeriesOrgCatForm from '@/event/forms/series/EventSeriesOrgCatForm.vue';
import { useFormRegistry } from '@/event/forms/useFormRegistry';
import { useActiveCard } from '@/forms/composables/useActiveCard';
import { useFluent } from 'fluent-vue';
import { computed, useTemplateRef } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

const props = defineProps<{ seriesId: string }>();
const fluent = useFluent();

const seriesId = computed(() => props.seriesId);
const { series } = useEventSeriesInjection();

const {
    activeCard,
    resetActiveCard,
    onEnterEditMode,
    showForm,
    editButtonDisabledMessage,
    saveButtonDisabledMessage,
    getCardStatus,
} = useActiveCard();

const seriesOrgCatFormRef = useTemplateRef('seriesOrgCatFormRef');

const { register, saveForm, discardChanges, leaveEditMode, resetAll } = useFormRegistry();

register('orgcat', seriesOrgCatFormRef);

onBeforeRouteLeave(() => {
    if (activeCard.value.id && activeCard.value.status === 'Edit-Touched') {
        if (!confirm(fluent.$t('leave-page-warning'))) {
            return false;
        }
        resetAll();
    }
    resetActiveCard();
    return true;
});
</script>
